import useMediaQuery from './useMediaQuery';

const useIsLargeScreen = () => {
  return useMediaQuery('(min-width: 1024px)');
};

export default useIsLargeScreen;
